import React from 'react';

import { Badge } from './styles';

export default function BadgeActive({
  variant,
  outlined,
  light,
  pill,
  children,
  size = 'md',
  ...props
}) {
  return (
    <Badge size={size} type={variant} outlined={outlined} light={light} pill={pill} {...props}>
      {children}
    </Badge>
  );
}
